import Modal from 'components/Modal';
import Typography from 'components/Typography';
import Button from 'components/Button';
import toast from 'react-hot-toast';
import CopyIcon from '../../../icons/copy';
import styles from '../WebhookSettings.module.scss';

type SecretModalProps = {
  isOpen: boolean;
  onClose: () => void;
  secret: string;
};

function SecretModal({isOpen, onClose, secret}: SecretModalProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(secret);
    toast.success('Secret copied to clipboard');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.secretModal}
    >
      <Typography variant="h2">Webhook Secret</Typography>
      <div className={styles.secretRow}>
        <Typography variant="p" className={styles.secretHint}>
          This secret will only be shown once. Please copy and store it
          securely.
        </Typography>
        <div className={styles.secretValue}>
          <code className={styles.secretCode}>{secret}</code>
          <CopyIcon
            width={16}
            height={16}
            className={styles.copyIcon}
            onClick={handleCopy}
          />
        </div>
      </div>
      <div className={styles.buttonWrap}>
        <Button color="primary" onClick={onClose}>
          Done
        </Button>
      </div>
    </Modal>
  );
}

export default SecretModal;
